import type { ModalConfig } from "./types";

export const emailCampaignModalsModalUrlConfig = {
  // Email Campaign detail modal
  "email_campaigns-detail": {
    modalId: "email_campaigns-detail",
    entityName: "email_campaigns",
    singularParam: "emailCampaignId",
    pluralParam: "emailCampaignsId",
    displayName: "Email Campaign",
  },
} as const satisfies Record<string, ModalConfig>;
